// extracted by mini-css-extract-plugin
export var button = "_d6-4";
export var hasDarkBackground = "_d6-7";
export var hasLightBackground = "_d6-6";
export var iconWrapper = "_d6-0";
export var large = "_d6-2";
export var medium = "_d6-1";
export var small = "_d6-5";
export var xsmall = "_d6-3";